import React, { PropsWithChildren, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { IconChevronDown, IconChevronUp } from '@pentabd/icons';
import classNames from 'classnames';

import { Button, ButtonProps } from '../button';

import Text from '../text/Text';

export interface ExpendableProps {
  title: string;
  buttonProps?: ButtonProps;
  bgColor?: string;
}

export default function Expendable({
  title,
  buttonProps,
  bgColor = 'bg-light',
  children,
}: PropsWithChildren<ExpendableProps>) {
  const [height, setHeight] = useState<number | string>(0);

  return (
    <div className={classNames('rounded', { [bgColor]: bgColor })}>
      <div className="d-flex w-100 justify-content-between rounded p-10">
        <Text size="lg" weight="semibold">
          {title}
        </Text>
        <Button
          fill="transparent"
          type="light"
          isPadding={false}
          onClick={() => setHeight(height === 0 ? 'auto' : 0)}
          className="order-2"
          {...buttonProps}
        >
          {height === 0 ? (
            <div className="d-flex align-items-center">
              <IconChevronDown size="20" type="light" />
            </div>
          ) : (
            <div className="d-flex align-items-center">
              <IconChevronUp size="20" type="light" />
            </div>
          )}
        </Button>
      </div>
      <AnimateHeight
        duration={500}
        height={height as number}
        className="order-1"
      >
        <div className="px-10 pb-10">{children}</div>
      </AnimateHeight>
    </div>
  );
}
